import React, { Component } from 'react';
import { breaktimeSchema } from '../../../schema/take-a-break';
import { filter, formData, dissableFormData } from '../../../schema/apppointment';
// import Select2 from '../../../components/FormComponent/select2';
import Select2 from '../../../components/FormComponent/select2';
import { Modal, Button,Select } from 'antd';
import { mapObjIndexed } from 'ramda';
import { cabinSchema } from './../../../schema/cabin-select';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import moment from 'moment';
import userTrackService from './../../../services/usertrack-service';
import Storage from './../../../services/local-store';
import ReactStopwatch from 'react-stopwatch';

const $ = require('jquery');
const Option = Select.Option;
class Counsellor_Start extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            break_status: null,
            break_time: null,
            formData: [],
            break_timer: null,
            cousellinSationData:[],
            workStationKey:'inital',
            counselling_diable:false,
            token_number:null,
            counsellingStationName:null,
            breakTimeDuration:2,
            break_of_counts:0,
            BreakAttempts:0,
            breakAlertModel:false,
            NoActionTimeForbreak:null,
            break_time_starting:null,
            number_of_extend:0,
            show_token_assgin_message:false
            
        }
    }
    showModal = () => {

        var formFeilds = this.state.formData;
        var data = {}

        formFeilds.map((sva, key) => {
            data[sva['name']] = sva['value'];
            data['cabin_name'] = sva['text'];


        });
        const { saveCabinIDInUser } = networkList;
        localStorage.setItem('cabin_id', data.cabin_id);
        localStorage.setItem('cabin_name', data.cabin_name);
        if (data.cabin_id !== null) {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Save Cabin Id in user - Request",
                    "date": new Date(),
                    "meta": data
                }
            }
            userTrackService(Userlogobj);
            postService(saveCabinIDInUser, 'POST', { "data": data }).then(res => {
                let logres={
                    data:[{}],
                    status:true
                }
                const UserlogobjRes = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Save Cabin Id in user - Response",
                        "date": new Date(),
                        "meta": logres
                    }
                }
                userTrackService(UserlogobjRes);
                if (res.status) {
                    this.setState((state) => ({ 'loadding': false }))
                    this
                        .props
                        .history
                        .push(`/counselling/counsellor-view`);
                }else {
                    Modal.error({
                        title: 'Failure',
                        content: "Oops! something went wrong... Please try again.",
                    });
                }
            })
        } else {
            this.setState((state) => ({ 'loadding': false }))
            Modal.error({
                title: 'Error message',
                content: 'Please Select Cabin',
                onOk: function () {
                    window.scrollTo(0, 0);
                }
            });
        }

        // this
        //     .props
        //     .history
        //     .push(`/counselling/counsellor-view`);

        // this.setState({
        //     visible: true
        // })
    }
    componentDidMount(){
     this.cousellingdropDown()
        cabinSchema['feilds'].map((feild, key) => {
            cabinSchema['feilds'][key]['value'] = null;
            cabinSchema['feilds'][key]['disable'] = false;
            cabinSchema['feilds'][key]['valid'] = false;
            cabinSchema['feilds'][key]['errors'] = [];
            delete cabinSchema['feilds'][key]['text'];

        })
        this.setState((state) => ({ 'loadding': false, 'formData': cabinSchema['feilds'] }));
        let cabin_id = localStorage.getItem('cabin_id');
        let cabin_name = localStorage.getItem('cabin_name');
        if (cabin_id !== "null") {
            cabinSchema['feilds'].map((feild, key) => {
                cabinSchema['feilds'][key]['value'] = cabin_id;
                cabinSchema['feilds'][key]['text'] = cabin_name;
            })
            this.setState((state) => ({ 'loadding': false, 'formData': cabinSchema['feilds'] }));
        }
        this.interval = setInterval(() => this.checkBreak(), 5000);
    }

    componentDidUpdate(prevProps,PrevState){
        // let prevbreak_status = PrevState.break_status;
        // let {break_status,workStationKey} = this.state;
        // console.log(prevbreak_status,break_status,workStationKey);
        // if(workStationKey!=='update'){
        //     if(prevbreak_status === 0 && break_status === 0){
        //         this.checkBreak();
        //     }
        // }
       
    }

    componentWillUnmount(){
        clearInterval(this.interval)
    }

    cousellingdropDown(){
        try {
          let  defaultValue=''
            postService('getCounsellingStationsByUser', 'GET', 'null').then(async res => {
                if (res) {
                    let newData = [];
                    let user_data = ''
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                        user_data = JSON.parse(localStorage.getItem('user_data'))
                       }  
                       console.log('user_data',user_data);
                       let couselling_station_id=localStorage.getItem('couselling_station_name')
                       if(couselling_station_id){
                        defaultValue=couselling_station_id
                       }else{
                        if(user_data['latest_counselling_station_id']){
                            defaultValue=user_data['latest_counselling_station_id']
                           }else{
                            defaultValue=user_data['counselling_station_id']
                           }
                       }
                      
                    if (res.data&&res.data.length !== 0) {
                   let activeCounseller=res.data.filter((item )=>{
                            return item.counselling_station_id===defaultValue
                        })
                        res.data.map((data, key) => {
                            newData.push({
                                // 'disabled':  (defaultValue !== null && defaultValue == data['counselling_station_id']) ? true : false,
                                'id': data['counselling_station_id'],
                                'name': data['counselling_station_name']
                            })
                        })
                        if(activeCounseller.length>0){
                            this.setState((state) => ({ cousellinSationData: newData, loading: false, fetching: false,defvalue:defaultValue,workStationKey:'inital',counsellingStationName:activeCounseller[0].counselling_station_name,activeCounseller }));
                        }else{
                            defaultValue=newData[0].id;
                            this.setState((state) => ({ cousellinSationData: newData, loading: false, fetching: false,defvalue:newData[0].id,workStationKey:'inital',activeCounseller })); 
                        }
                        localStorage.setItem('couselling_station_name', defaultValue);
                      await  this.updateCousellingStation(defaultValue,'inital');
                      await this.getAssignedTokensforCounseller();
                     
                    }
                } else {
                    this.setState({ fetching: false });
                }
            });
        } catch (error) {
            this.setState((state) => ({ 'selet_options': [] }));
            console.log(error);
        }
    }

    updateCousellingStation(value,key ){
        let {formData}=this.state
        let payload={
            counselling_station_id:value
        }
        try {
              postService('setLatestWorkstationByUser', 'POST', {data:payload}).then(res => {
                  if (res.status) {
                    localStorage.setItem('couselling_station_name', value);
                   this.setState({defvalue:value,workStationKey:key,formData})
                   if(key==='inital'){
                    this.checkBreak();
                   }else{
                            let user_data = ''
                            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                                user_data = JSON.parse(localStorage.getItem('user_data'))
                            } 
                            let payload={
                                "user_id": user_data['id']
                        }
                        try {
                            postService('ReleaseUserCabin', 'POST', { 'data': payload }).then(res => {
                            })
                        }catch (error) {
                            this.setState((state) => ({ 'selet_options': [] }));
                            console.log(error);
                        }

                    formData.map((feild, key) => {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                    })
                    this.setState({formData})
                   }
                  
                  } 
              });
          } catch (error) {
              this.setState((state) => ({ 'selet_options': [] }));
              console.log(error);
          }
    }
    componentWillUnmount() {
        clearInterval(this.checkPatient);
        localStorage.removeItem('break_time_starting');
        localStorage.removeItem('number_of_extend');
    }
    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }
    handleChange(ele) {
          let payload={
            cabin_id:ele.value
          }
          try {
            postService('saveCabinIDInUser', 'POST', { "data": payload }).then(res => {
                let logres={
                    data:[{}],
                    status:true
                }
                const UserlogobjRes = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Save Cabin Id in user - Response",
                        "date": new Date(),
                        "meta": logres
                    }
                }
                userTrackService(UserlogobjRes);
               
            })
        }catch (error) {
            console.log(error);
        }
       
        }

    checkBreak() {
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get User Break Status - Request",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                // let all_BreakTimeReasons= localStorage.getItem('all_BreakTimeReasons')
                let all_BreakTimeReasons= Storage.get('all_BreakTimeReasons')
                all_BreakTimeReasons=all_BreakTimeReasons && all_BreakTimeReasons.length>0?JSON.parse(all_BreakTimeReasons):[]
                let breakData=[]
                if(all_BreakTimeReasons && all_BreakTimeReasons.length>0){
                    breakData=  all_BreakTimeReasons.filter((item)=>{
                        if(item.id==res['data']['latest_breakreason_id']){
                            return item.break_time;
                        }
                    })
                }
                this.setState({ 'break_status': res['data']['break_status'] ? res['data']['break_status'] : 0,'break_time': res['data']['start_time'],break_time_starting:res['data']['start_time'],breakTimeDuration:breakData.length>0&&breakData[0].break_time});
                if (res['data']['break_status']) {
                    this.setdatebreakTime(false);
                    this.breakCounter();
                }
            } else {
                this.setState({ 'break_status': 0,'break_time':null,break_time_starting:null})
            }
        });
    }

    stopBreak = () => {
        let {break_time,breakTimeDuration}=this.state
        let extends_count= localStorage.getItem('number_of_extend')
        let payload={
            "number_of_extends":extends_count?parseInt(extends_count):0,
            "start_time":break_time,
            'breakTimeDuration':breakTimeDuration
        }
        postService('updateIdlestoptime', 'POST', {'data':payload}).then(res => {
            if (res.status) {
                Storage.store('break_status',0);
                this.setState({ 'break_status': 0,'break_time':null,break_time_starting:null,breakAlertModel:false },()=>{
                    var formFeilds = this.state.formData;
        var data = {}

        formFeilds.map((sva, key) => {
            data[sva['name']] = sva['value'];
            data['cabin_name'] = sva['text'];


        });
        if (data.cabin_id !== null) {
            this
            .props
            .history
            .push(`/counselling/counsellor-view`);
        }
                      
                })
            }
        });
    }
    // break counter
    breakCounter = () => {
        let { break_time, break_status } = this.state
        // Set the date we're counting down to
        var m = moment(break_time).format('MMM DD, YYYY HH:mm:ss')
        console.log(m)
        var countDownDate = new Date(m).getTime();
        var This = this
        // Update the count down every 1 second
        var x = setInterval(function () {
            // Get today's date and time
            var now = new Date().getTime();
            // Find the distance between now and the count down date
            var distance = now - countDownDate;
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            This.setState({ days: days, hours: hours, minutes: minutes, seconds: seconds })
            // If the count down is over, write some text 
            if (break_status === 0) {
                clearInterval(x);
                document.getElementById("demo").innerHTML = "";
            }
        }, 1000);
    }
    handleCancel(){
        console.log('Cancel button clicked');
    }
    onChange(value) {
        let This=this
        let {formData}=This.state
        Modal.confirm({
            title: 'Are you sure you want to change the Counselling Station?',
            content: '',
            onOk: function () {
                // let payload={
                //     "cabin_id":null,
                //     "cabin_name": null,
                //     "counselling_station":null
                // }
                // postService('saveCabinIDInUser', 'POST', { "data": payload }).then(res => {
                //     let logres={
                //         data:[{}],
                //         status:true
                //     }
                    
                    
                // })
                This.updateCousellingStation(value,'update');
            },
            onCancel() {This.handleCancel();}
        }); 
        formData.map((feild, key) => {
            formData[key]['disable'] = formData[key]['value']===false;

        })
        this.setState({formData:formData})
       
    }

    getAssignedTokensforCounseller(){
        let {formData,counselling_diable,token_number,counsellingStationName,activeCounseller,show_token_assgin_message}=this.state;
        try {
            postService('getAssignedTokensforCounseller', 'GET', 'null').then(res => {
                if (res.status) {
                    if(res.data.length>0){
                        formData.map((feild, key) => {
                            formData[key]['disable'] = formData[key]['value']===null?false:true;

                        })
                        show_token_assgin_message=true
                        token_number=res.data[0].current_token_count
                        if(activeCounseller.length>0&&res.data[0].counselling_station_id&&activeCounseller[0].counselling_station_id===res.data[0].counselling_station_id){
                            counsellingStationName=counsellingStationName
                            counselling_diable=true;
                        }else{
                            counselling_diable=false;
                            counsellingStationName=res.data[0].counselling_station_name
                        }
                        
                    }else{
                        formData.map((feild, key) => {
                            formData[key]['disable'] = false;
                            
                        })
                        counselling_diable=false;
                        token_number=null;
                    }
                  
                this.setState({formData,counselling_diable,token_number:token_number,counsellingStationName,show_token_assgin_message})
                } 
            });
        } catch (error) {
            
            console.log(error);
        }
    }
    counsellorStayHere(){
        this.setState((state) => ({ breakAlertModel:false,NoActionTimeForbreak:null}), () => {
            localStorage.setItem('break_time_starting',moment());
            this.setdatebreakTime(true);
            this.setState({breakAlertModel:false,NoActionTimeForbreak:null,break_time_starting:moment()})
        })
    }

    setdatebreakTime = async(status)=>{
             let    break_time_starting= localStorage.getItem('break_time_starting');
             let {number_of_extend}=this.state
             if(break_time_starting){
                     this.setState({break_time_starting,breakAlertModel:false})
                 }
               let extends_count= localStorage.getItem('number_of_extend')
               if(status){
                if(extends_count){
                    extends_count=extends_count?(parseInt(extends_count))+1:1
                    localStorage.setItem('number_of_extend',extends_count)
                 }else{
                    extends_count=extends_count?(parseInt(extends_count))+1:1
                    localStorage.setItem('number_of_extend',extends_count)
                 }  
               }
               
           
             
       }
    render() {
        let userName = JSON.parse(localStorage.getItem('user'));
        let { break_status,break_time,formData, days, hours, minutes, seconds,cousellinSationData,defvalue,token_number,counsellingStationName,breakTimeDuration,break_of_counts,BreakAttempts,breakAlertModel,NoActionTimeForbreak,break_time_starting,show_token_assgin_message } = this.state;
        console.log()  
        console.log('break_status',break_status,cousellinSationData);
        const children = [];
        if(cousellinSationData.length>0){
            cousellinSationData.map((data, key) => {
                if (data.id !== null) {
                    children.push(
                        <Option key={key} value={data.id} disabled={data.disabled ? data.disabled : false}>{data.name
                            ? data.name
                            : (data.value ||data.service_name)}</Option>
                    );
                }
    
            });
        }
        
        return (
            <div className="card p-5 m-5 cou-dash">
                <div className="row mx-auto">
                    <div className="text-center">
                        {break_status === 0 && <React.Fragment>
                            <h1 className="text-capitalize text-center pb-4 mb-0">Welcome, {userName}</h1>
                            <h6 className="mx-auto text-center">Patients are waiting in the queue for your advice.</h6>
                            <h6 className="mx-auto text-center pb-3">Select Cabin and Click to start counselling. </h6>
                           { this.state.show_token_assgin_message &&<p style={{color:'red'}}>Please complete the assigned token no : <span style={{fontWeight:'600',color:'black'}}>{token_number}</span> in <span style={{fontWeight:'600',color:'black'}}>{counsellingStationName}</span> before switching the Counselling Station!</p>}
                            <div className="mx-auto text-center">
                                {(formData !== undefined) && <React.Fragment>

                                    {formData
                                        .map((feild, key) => {
                                            if (feild.element === 'select2' && feild.visible && feild.name==='cabin_id') {
                                                return (
                                                    <React.Fragment key={key}>
                                                        {(feild.name === 'patient_list') &&
                                                            <div className="col-6">
                                                                <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                            </div>}
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} my-2 ${this.state.show_token_assgin_message?'counselling_diable' :feild.name}`}
                                                            key={key}>
                                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                            <Select2
                                                                selectdata={feild}
                                                                changedObj={this.state.changedObj}
                                                                {...this.props}
                                                                {...this.state}
                                                                Queuedata={this.state.formData}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this)} /> {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }else{
                                                return (
                                                    <React.Fragment key={key}>
                                                        {(feild.name === 'patient_list' ) &&
                                                            <div className="col-6">
                                                                <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                            </div>}
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} my-2 ${this.state.show_token_assgin_message?'counselling_diable' :feild.name}`}
                                                            key={key}>
                                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                            <Select
                                                            showSearch
                                                            // mode={mode}
                                                            style={{
                                                                width: '100%',
                                                                height: '30px'
                                                            }}
                                                            placeholder={feild.placeholder}
                                                            // defaultValue={defvalue}
                                                            // allowClear={defaultallowClear}
                                                            value={defvalue}
                                                            optionFilterProp="children"
                                                            onChange={this
                                                                .onChange
                                                                .bind(this)}
                                                            // notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                                                            // onSearch={this.onSearch}
                                                            disabled={this.state.counselling_diable}
                                                            loading={false}
                                                            // menuItemSelectedIcon={< Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                            dropdownMatchSelectWidth={false}>
                                                            {children}
                                                        </Select>
                                                                    {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                        </div>
                                                    </React.Fragment>
                                                ) 
                                            }
                                        })
                                    }
                                </React.Fragment>}
                            </div>
                            <div><button className="btn btn-success text-capitalize mt-5" onClick={this.showModal}>Start Counselling</button></div></React.Fragment>}
                            {break_status === 1 && <React.Fragment>
                            {/* <h1 className="text-capitalize text-center pb-4 mb-0">Welcome, {userName}</h1> */}
                            <h6 className="mx-auto text-center">You are on Break from {break_time ? moment(break_time).format('DD-MM-YYYY HH:mm A') : ''}</h6>
                            {/* <h6 className="mx-auto text-center py-3"><ClockCircleOutlined className="align-bottom" /> {days ? days +'d' : null}{hours?hours+'h':null}{minutes?minutes+'m':null}<span className="position-absolute">{seconds?seconds+'s':null}</span> </h6> */}
                            {/* <div id="countdown">
                                <ul>
                                    <span><img src="/assets/images/icons/clock-circular-outline@3x.png"></img></span>
                                
                                    {days ? <li><span>{days}</span>days</li> : null}
                                    {hours ? <li><span>{hours}</span>Hours</li> : null}
                                    {minutes ? <li><span>{minutes}</span>Minutes</li> : null}
                                    {seconds || seconds == 0 ? <li><span>{seconds}</span>Seconds</li> : null}
                                </ul>
                            </div> */}
 <div className='col-12'>
                                    <ReactStopwatch
                                        seconds={30}
                                        minutes={0}
                                        hours={0}
                                        render={({hours, minutes, seconds }) => {
                                    var current_hours=0;
                                    var  current_minutes=0;
                                    var current_seconds=0;
                                if(current_minutes<=(parseInt(breakTimeDuration)) && break_time_starting!==null){
                                    var now = moment(new Date()); //todays date
                                    var end = moment(break_time_starting); // another date
                                    const duration = moment.duration(now.diff(end));
                                    current_minutes = duration.minutes();
                                    current_seconds = duration.seconds();  
                                }
                                  
                                    if(current_minutes>=(parseInt(breakTimeDuration))){
                                        console.log('BreakAttempts',BreakAttempts,break_of_counts);
                                  if(BreakAttempts!==null){
                                    let  NoActionTimeForbreak=moment();
                                    this.setState({breakAlertModel:true,BreakAttempts:(BreakAttempts+1),break_time_starting:null,NoActionTimeForbreak:NoActionTimeForbreak})
                                    var audio = new Audio('/assets/announcement.mp3')
                                        audio.play();
                                  }
                                //   else{
                                //     this.setState({break_time_starting:null})
                                //     this.stopBreak();  
                                //     // this.takeabreakSubmit();
                                //   }
                                    }
                                
                            return (
                                <div style={{textAlign:'center'}}>
                                    <h3 className='pb-1' style={{ 'fontSize': '2pc',paddingRight:'50px' }}>{current_minutes?current_minutes+'m:':null}<span className="position-absolute">{current_seconds?current_seconds+'s':null}</span></h3>

                                </div>
                            );
                                        }}

                                    />
                                </div>

                            <br></br>
                            <h6 className="mx-auto text-center">Stop the break time to start Counselling.</h6>
                            <div><button className="btn btn-danger text-capitalize mt-4 px-4" onClick={this.stopBreak}>Stop Break</button></div></React.Fragment>}
                    </div>
                </div>

                {breakAlertModel && <Modal visible={breakAlertModel} footer={null}  width={600}>
                    <div className="token-popup">
                        <h3 className="text-center ">Do you want to End or Extend your break?</h3>
                        <div class="pt-4">
                        <div className='col-12'>
                            {(NoActionTimeForbreak!==null  ) &&     <ReactStopwatch
                                        seconds={30}
                                        minutes={0}
                                        hours={0}
                                        render={({hours, minutes, seconds }) => {
                                    var current_hours=0;
                                    var  current_minutes_alert=0;
                                    var current_seconds_alert=0;
                                    console.log('NoActionTime',NoActionTimeForbreak,current_minutes_alert);
                                if(current_minutes_alert<=1 && NoActionTimeForbreak!==null){
                                    var now = moment(new Date()); //todays date
                                    var end = moment(NoActionTimeForbreak); // another date
                                    const duration = moment.duration(now.diff(end));
                                    current_minutes_alert = duration.minutes();
                                    current_seconds_alert = duration.seconds();  
                                }
                                
                                    if(current_minutes_alert>=1 && breakAlertModel ){
                                        this.setState({break_id:1,NoActionTimeForbreak:null,noactionStatus:false})
                                        this.counsellorStayHere()
                                        // this.takeabreakSubmit();
                                    }
                                
                            return (
                                <div style={{textAlign:'center'}}>
                                    <h3 className='pb-1' style={{ 'fontSize': '1pc',paddingRight:'50px',color:'red' }}>{current_minutes_alert?current_minutes_alert+'m:':null}<span className="position-absolute">{current_seconds_alert?current_seconds_alert+'s':null}</span></h3>

                                </div>
                            );
                                        }}

                                    />}
                                </div>
                                {/* <button className="btn btn-danger text-capitalize mt-4 px-4" onClick={this.stopBreak}>Stop Break</button> */}
                        <button className="btn btn-danger px-5 mx-2 ml-5 mt-5" onClick={this.stopBreak}>Stop Break</button>
                        <button className="btn btn-next text-capitalize mr-3 mt-5 ml-5" onClick={() => { this.counsellorStayHere() }}>Extend Break</button>
                        </div>
                    </div>
                    </Modal>}
            </div>

        )

    }
}
export default Counsellor_Start;